module.exports = __webpack_public_path__ + "public/StoreIcon/Manage-items.svg?beb2eea6";